import styled from '@emotion/styled';
import { Colors, helperTypographyText } from '@utex/ui-kit';

export const Content = styled('p')`
  ${helperTypographyText({
    size: 'M',
  })};

  a {
    color: ${Colors.text.default};

    &:hover,
    &:focus {
      color: ${Colors.text.default};
    }
  }
`;
